import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/global/providers/Providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Web3Provider"] */ "/vercel/path0/global/providers/Web3Provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/vercel/path0/modules/shared/components/google-analytics/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@rainbow-me/rainbowkit/dist/index.css");
